import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import { useAuth } from "@/hooks/use-auth";

/**
 * Boots the session and renders global providers + a router outlet.
 */
function AuthBoot({ children }: { children: React.ReactNode }) {
  const { fetchUser } = useAuth();
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);
  return <>{children}</>;
}

export function RootLayout() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <ThemeProvider defaultTheme="system">
      <QueryClientProvider client={queryClient}>
        <AuthBoot>
          <Outlet />
        </AuthBoot>
        <Toaster richColors position="bottom-right" />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
